/*    
<summary>
   This functional loginlayout component redirect the user to landing page of application if he attemps to go to login page
   after loggedin into the application. 
   Developer:Aashish Singh, Created Date:08-Mar-2023
</summary>
<returns>Returns JSX</returns>
*/
import React from 'react';
import { Redirect } from 'react-router-dom';
import authStore from '../../core/stores/auth-store';
import './LoginLayout.css';
import { redirectToDefaultRoute } from '../../helpers/route-helper';
const LoginLayout: React.FC<any> = (props) => {
    const { getToken, isAuthenticated } = authStore;
    return (
        <React.Fragment>
            {(!isAuthenticated && !getToken) ? props.children : <Redirect to={redirectToDefaultRoute()} />}
        </React.Fragment>
    );
};
export default LoginLayout;
